import { render, staticRenderFns } from "./UserConfirmBookingModal.vue?vue&type=template&id=5137fe5c&scoped=true&"
import script from "./UserConfirmBookingModal.vue?vue&type=script&lang=ts&"
export * from "./UserConfirmBookingModal.vue?vue&type=script&lang=ts&"
import style0 from "./UserConfirmBookingModal.vue?vue&type=style&index=0&id=5137fe5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5137fe5c",
  null
  
)

export default component.exports